const DEFAULT_TENANT_REDUX_STATE = {
  loadingCustomData: true,
  customDataLoaded: false,
  customData: null,
};

export default DEFAULT_TENANT_REDUX_STATE;
